import { render } from "./BaseRowField.vue?vue&type=template&id=72f125e1"
import script from "./BaseRowField.vue?vue&type=script&lang=js"
export * from "./BaseRowField.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__